import { createContext, useContext } from 'react';

export interface PortalCustomization {
  backgroundUrl: string | null;
  welcomeMessage: string | null;
  accentColor: string | null;
}

export const PortalCustomizationContext = createContext<PortalCustomization>({
  backgroundUrl: null,
  welcomeMessage: null,
  accentColor: null,
});

export function usePortalCustomization() {
  return useContext(PortalCustomizationContext);
}